import { Button } from "@chakra-ui/react";

const CustomButton = ({ buttonText, action }) => {
    return (
        <Button
            colorScheme={"teal"}
            variant={"solid"}
            type='button'
            w={{ base: "100%", sm: "auto" }}
            size={{ base: "sm", md: "sm" }}
            onClick={action}
        >
            {buttonText ? buttonText : '新規登録'}
        </Button>
    )
};

export default CustomButton;